import { Controller } from "@hotwired/stimulus";
import { writeTextToClipboard } from "../helpers/clipboard";

export default class extends Controller {
  static targets = ["copiedIndicator", "copyButton"];

  async copy(event) {
    event.preventDefault();
    event.stopPropagation();
    const ok = await writeTextToClipboard(event.currentTarget.dataset.textToCopy);
    if (!ok) return;

    this.#showCopiedIndicator();
  }

  disconnect() {
    this.#clearCopiedIndicatorTimeout();
  }

  #showCopiedIndicator() {
    this.#clearCopiedIndicatorTimeout();

    if (!this.hasCopiedIndicatorTarget) {
      return;
    }

    if (this.hasCopyButtonTarget) {
      this.copyButtonTarget.classList.add("hidden");
    }

    this.copiedIndicatorTarget.classList.remove("hidden");

    this.hideIndicatorTimeout = setTimeout(() => {
      this.copiedIndicatorTarget.classList.add("hidden");
      if (this.hasCopyButtonTarget) {
        this.copyButtonTarget.classList.remove("hidden");
      }
    }, 3000);
  }

  #clearCopiedIndicatorTimeout() {
    if (this.hideIndicatorTimeout) {
      clearTimeout(this.hideIndicatorTimeout);
      this.hideIndicatorTimeout = null;
    }
  }
}
